import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class ContactUsService {
	getData(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/contactUs?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new ContactUsService();
